// extracted by mini-css-extract-plugin
export default {"products":"Pv-z","card":"Qv-z","oosMessaging":"Rv-z"};